document.querySelectorAll(".grid__item").forEach((product) => {
  const selects = product.querySelectorAll("variant-selects .select");

  selects.forEach((select) => {
    select.addEventListener("change", () => {
      const productSelectedVariants =
        product.querySelectorAll(".select select");
      let selectedOptionsValues = [];

      // Get the selected options values
      productSelectedVariants.forEach((variant) => {
        const selectedOption = variant.options[variant.selectedIndex];
        const selectedOptionValue = selectedOption.value;

        selectedOptionsValues.push(selectedOptionValue);
      });

      const productVariants = JSON.parse(
        product.querySelector(".product-card-info").dataset.productVariants
      );
      const selectedVariant = productVariants[selectedOptionsValues.join("")];

      if (!selectedVariant) return;

      // Change the ID of the selected variant in the input
      const selectedVariantInput = product.querySelector(".selected-variant");
      selectedVariantInput.dataset.selectedVariant =
        selectedVariant.options.join("");

      // Change product price
      const product_price = selectedVariant.price;

      const currentPrices = product.querySelectorAll(
        ".price-item.price-item--show"
      );

      currentPrices.forEach((price) => {
        price.innerHTML = product_price;
      });
    });
  });
});
